"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartSortingDropdown = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var AttributeDropdown_1 = require("./AttributeDropdown/AttributeDropdown");
var getAttributeName = function (bucketItemNames, available) {
    return bucketItemNames[available.itemId.localIdentifier].name;
};
exports.ChartSortingDropdown = function (_a) {
    var currentSort = _a.currentSort, availableSorts = _a.availableSorts, bucketItemNames = _a.bucketItemNames, intl = _a.intl, onSelect = _a.onSelect, disabledExplanationTooltip = _a.disabledExplanationTooltip, enableRenamingMeasureToMetric = _a.enableRenamingMeasureToMetric;
    var onSortChanged = react_1.useCallback(function (newSort, index) {
        var newSortItems = tslib_1.__spread(currentSort);
        newSortItems[index] = newSort;
        onSelect(newSortItems);
    }, [onSelect, currentSort]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "sort-attribute-section" }, currentSort &&
            currentSort.map(function (currentSortItem, index) {
                // Obtain availables items with same id as current index
                var available = availableSorts[index];
                return (react_1.default.createElement("div", { key: index, className: "sort-attribute-item" },
                    currentSort.length > 1 && (react_1.default.createElement("div", { className: "attribute-sorting-title" }, getAttributeName(bucketItemNames, available))),
                    react_1.default.createElement(AttributeDropdown_1.AttributeDropdown, { index: index, currentSortItem: currentSortItem, availableSorts: available, bucketItemNames: bucketItemNames, disabledExplanationTooltip: disabledExplanationTooltip, intl: intl, onSelect: function (newSort) {
                            onSortChanged(newSort, index);
                        }, enableRenamingMeasureToMetric: enableRenamingMeasureToMetric })));
            }))));
};
//# sourceMappingURL=ChartSortingDropdown.js.map